import Swiper, { Navigation, Pagination } from 'swiper';

Swiper.use([Navigation, Pagination]);
class Slider {
  private component: NodeListOf<HTMLElement>;
  private trigger: NodeListOf<HTMLElement>;

  constructor() {
    this.component = document.querySelectorAll('[data-component="slider"]');
    this.trigger = document.querySelectorAll('[data-trigger="slider"]');

    if (this.component && this.trigger) {
      this._init();
    }
  }

  private _init() {
    this.trigger.forEach((element) => {
      let mySwiper: any = null;

      const firstImage = element.querySelector('img');
      if (firstImage) {
        firstImage.onload = () => {
          if (mySwiper) {
            mySwiper.update();
          }
        };
      }

      mySwiper = new Swiper(element, {
        spaceBetween: 30,
        preloadImages: false,
        watchOverflow: true,
        slidesPerView: 'auto',
        freeMode: true
      });
    });
  }
}

export const sliderPictoTect = new Slider();
